
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {mapState} from 'vuex'
import less from 'less'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'

import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.use(less)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)

Vue.use(require('vue-wechat-title'))

Vue.use(VueLazyload, {
  //预加载高度
  preLoad: 1.3,
  //错误时显示的图片
  error: '',
  //图片加载中显示的图片
  loading: 'static/index/loading.gif',
  //尝试加载次数
  attempt: 1
})

window.Vue = Vue
window.mapState = mapState

export default {}



// WEBPACK FOOTER //
// ./src/utils/impLibs/ImpOther.js